import type { ReactNode } from 'react'

import { Breadcrumbs } from './breadcrumbs'
import { Header } from './header'
import { ThemeSwitch } from './theme-switch'

export function AppHeader({
  current,
  trail,
  center,
  end,
}: {
  current?: string
  trail?: ReactNode
  center?: ReactNode
  end?: ReactNode
}) {
  return (
    <Header
      fixed
      center={center}
      end={
        <>
          {end}
          <ThemeSwitch />
        </>
      }
    >
      {trail ?? <Breadcrumbs current={current} />}
    </Header>
  )
}
